<template>
  <div class="animated fadeIn">
    <b-container fluid class="px-0 product-list">
      <b-card header-bg-variant="primary" border-variant="primary" header="Filtros">
        <b-row>
          <b-col lg="4" class="px-4 py-2">
            <label><strong>SKU ID</strong></label>
          </b-col>
          <b-col lg="4" class="px-4 py-2">
            <label><strong>UPC</strong></label>
          </b-col>
          <b-col lg="4" class="px-4 py-2">
            <label><strong>Cantidad</strong></label>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" class="px-4 py-2">
            <b-form-group id="skuDesdeInputForm"
              horizontal
              :label-cols="4"
              breakpoint="md"
              :invalid-feedback="!isValidInteger(filter.sku.desde, false)? 'No es un valor válido' : ''"
              :state="isValidInteger(filter.sku.desde, false)"
              label="Desde"
              label-for="skuDesdeFormatter">
              <b-input-group>
                <b-form-input id="skuDesdeInputFormatter" v-model="filter.sku.desde"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="px-4 py-2">
            <b-form-group id="upcDesdeInput"
              horizontal
              :label-cols="4"
              breakpoint="md"
              :invalid-feedback="!isValidInteger(filter.upc.desde, false)? 'No es un valor válido' : ''"
              :state="isValidInteger(filter.upc.desde, false)"
              label="Desde"
              label-for="upcDesdeFormatter">
              <b-input-group>
                <b-form-input id="upcDesdeInputFormatter" v-model="filter.upc.desde"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="px-4 py-2">
            <b-form-group id="inventoryFromQuantityInput"
              horizontal
              :label-cols="4"
              breakpoint="md"
              :invalid-feedback="!isValidInteger(filter.fromQuantity, false)? 'No es un valor válido' : ''"
              :state="isValidInteger(filter.fromQuantity, false)"
              label="Desde"
              label-for="inventoryFromQuantity">
              <b-input-group>
                <b-form-input id="inventoryFromQuantity" v-model="filter.fromQuantity"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" class="px-4 py-2">
            <b-form-group id="skuHastaInput"
              horizontal
              :label-cols="4"
              breakpoint="md"
              label="Hasta"
              :invalid-feedback="validIntegerCompare(filter.sku.hasta, filter.sku.desde, false)"
              :state="validIntegerCompare(filter.sku.hasta, filter.sku.desde, false) === ''"
              label-for="skuHastaFormatter">
              <b-input-group>
                <b-form-input id="skuHastaInputFormatter" v-model="filter.sku.hasta"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="px-4 py-2">
            <b-form-group id="upcHastaInput"
                horizontal
                :label-cols="4"
                breakpoint="md"
                :invalid-feedback="validIntegerCompare(filter.upc.hasta, filter.upc.desde, false)"
                :state="validIntegerCompare(filter.upc.hasta, filter.upc.desde, false) === ''"
                label="Hasta"
                label-for="upcHastaFormatter">
              <b-input-group>
                <b-form-input id="upcHastaInputFormatter" v-model="filter.upc.hasta"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="px-4 py-2">
            <b-form-group id="inventoryToQuantityInput"
              horizontal
              :label-cols="4"
              breakpoint="md"
              label="Hasta"
              :invalid-feedback="validIntegerCompare(filter.toQuantity, filter.fromQuantity, false)"
              :state="validIntegerCompare(filter.toQuantity, filter.fromQuantity, false) === ''"
              label-for="inventoryToQuantity">
              <b-input-group>
                <b-form-input id="inventoryToQuantity" v-model="filter.toQuantity"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
            <b-row>
              <b-col lg="4" class="px-4 py-2">
                <b-form-group id="categoryInput"
                  horizontal
                  :label-cols="4"
                  breakpoint="md"
                  label="Categoria"
                  label-for="categoryFormatter">
                  <category-tree id='selectCategory'
                    :categorySelected="filter.category"
                    @onCategorySelected="selectCategory">
                  </category-tree>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-button class="float-right mr-2" :disabled="loading || disableFilter" variant="primary" @click.stop="filterTable" >Filtrar</b-button>
            <b-button class="float-right mr-2" :disabled="loading" variant="primary" @click.stop="cleanFilters" >Mostrar Todos</b-button>
            <b-button class="float-right mr-2" :disabled="loading || disableFilter" variant="primary" @click.stop="exportCSV" >Exportar CSV</b-button>
          </b-col>
        </b-row>
      </b-card>
      <b-card id="mainCard" class="mt-3" header-bg-variant="primary" border-variant="primary" header="Listado de inventario actual">
        <b-row class="mt-3">
          <b-col class="col-md-auto">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mb-3" />
          </b-col>
          <b-col class="col-md-auto per-page">
            <b-form-group id="perPage" horizontal label="Mostrar por página">
              <b-form-select :options="pageOptions" v-model="perPage" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-md-auto" align-self="start">
            Elementos de inventario encontrados <b>{{totalRows}}</b>
          </b-col>
        </b-row>
        <moon-loader :loading="loading" color="#000" size="30px"></moon-loader>
        <b-table class="mt-3" v-show="!loading" id="productTable"
          ref="productTable"
          show-empty
          striped
          hover
          small
          stacked="lg"
          :items="itemProvider"
          foot-clone
          :fields="fieldsProduct"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          responsive=true
          empty-text="No hay inventario para mostrar"
          empty-filtered-text="No hay invetario para mostrar">
          <template slot="category" slot-scope="row">
            {{row.item.category.name}}
          </template>
          <template slot="brand" slot-scope="row">
            {{row.item.brand.name}}
          </template>
          <template slot="action" slot-scope="row">
            <b-button v-if="row.item.skus.length > 0" size="sm" variant="link" @click.stop="row.toggleDetails">
              <span v-show="!row.detailsShowing"><i class="fa fa-plus"></i></span>
              <span v-show="row.detailsShowing"><i class="fa fa-minus"></i></span>
              {{ row.detailsShowing ? 'Ocultar' : 'Ver'}} Variantes ({{row.item.skus.length}})
            </b-button>
            <span v-else><b>No contiene variantes</b></span>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-card>
              <b-table v-show="!loading" id="productTable"
                ref="variantTable"
                show-empty
                hover
                :items="row.item.skus"
                :fields="fieldsVariant"
                responsive=true
                stacked="xl"
                empty-text="No hay variantes para mostrar"
                empty-filtered-text="No hay variantes para mostrar">
                <template  slot="inventory" slot-scope="row">
                  <div class="inventoryContainer" v-b-tooltip.hover title="La cantidad entre parentesis es stock reservado">
                    <span class="inventoryTotal">{{row.item.inventory.totalQuantity}}</span>
                    <span class="inventoryReserved">({{row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0}})</span>
                  </div>
                </template>
                <template slot="price" slot-scope="row">
                  {{currency}} {{row.item.price.listPrice}}<br>
                  <span class="discount">({{currency}} {{row.item.price.price}})</span><br>
                  {{row.item.price.priceValidUntil}}
                </template>
                <template slot="status"  slot-scope="data">
                  <b v-if="data.value === 'APPROVED'" class="text-success">
                    {{estados.find(p => p.value === data.value).text}}
                  </b>
                  <b v-if="data.value === 'REJECTED'" class="text-danger">
                    {{estados.find(p => p.value === data.value).text}}
                  </b>
                  <b v-if="data.value === 'PENDING_APPROVAL'" class="text-warning">
                    {{estados.find(p => p.value === data.value).text}}
                  </b>
                </template>
              </b-table>
            </b-card>
          </template>
        </b-table>
        <b-row class="mb-3">
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import appConfig from '@/config/applicationConfig.js'
import CategoryTree from '../catalog/CategoryTree'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import {InventoryServiceMixim} from '@/mixims/InventoryServiceMixim.js'
import {ProductServiceMixim, PRODUCT_STATES} from '@/mixims/ProductServiceMixim.js'
import { Utils } from '@/mixims/Utils'
import {ValidationsMixim} from '@/mixims/ValidationsMixim.js'

export default {
  name: 'inventory-report',
  components: { MoonLoader, CategoryTree },
  mixins: [InventoryServiceMixim, ValidationsMixim, ProductServiceMixim, Utils],
  props: ['rangeDate', 'account'],
  watch: {
    rangeDate: function (val, oldVal) {
      if (!val || !Array.isArray(val) || val.length < 2) {
        this.filter.fecha.desde = null
        this.filter.fecha.hasta = null
        return
      }
      this.filter.fecha.desde = val[0]
      this.filter.fecha.hasta = val[1]
      this.$refs.productTable.refresh()
    },
    account: function (val, oldVal) {
      this.filter.seller = val
      this.$refs.productTable.refresh()
    }
  },
  data () {
    return {
      fieldsVariant: [
        { key: 'skuName', label: 'Nombre', 'class': 'text-left' },
        { key: 'upc', label: 'UPC', 'class': 'text-left' },
        { key: 'id', label: 'SKU', 'class': 'text-left' },
        { key: 'price', label: 'Precio', 'class': 'priceCol text-left' },
        { key: 'status', label: 'Estado', 'class': 'text-left' },
        { key: 'inventory', label: 'Inventario', 'class': 'text-left' }
      ],
      fieldsProduct: [
        { key: 'id', label: 'Id', 'class': 'text-left', sortable: true },
        { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true },
        { key: 'category', label: 'Categoría', 'class': 'text-left', sortable: true },
        { key: 'brand', label: 'Marca', 'class': 'text-left', sortable: true },
        { key: 'skus', label: 'Estado', 'class': 'text-left', sortable: true, formatter: this.productTableState },
        { key: 'action', label: ' ', 'class': 'text-right', sortable: false }
      ],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [ 10, 15, 25, 50, 100 ],
      sortBy: null,
      locale: appConfig.LOCALE,
      currency: appConfig.CURRENCY,
      sortDesc: false,
      filter: {
        sku: {desde: null, hasta: null},
        upc: {desde: null, hasta: null},
        fecha: {desde: null, hasta: null},
        category: {id: null, text: null},
        fromQuantity: null,
        toQuantity: null,
        account: null
      },
      tableFilterInfo: null,
      loading: false,
      estados: PRODUCT_STATES
    }
  },
  computed: {
    disableFilter () {
      if (
        !this.isValidInteger(this.filter.sku.desde, false) ||
        this.validIntegerCompare(this.filter.sku.hasta, this.filter.sku.desde, false) !== '' ||
        !this.isValidInteger(this.filter.upc.desde, false) ||
        this.validIntegerCompare(this.filter.upc.hasta, this.filter.upc.desde, false) !== '' ||
        !this.isValidInteger(this.filter.fromQuantity, false) ||
        this.validIntegerCompare(this.filter.toQuantity, this.filter.fromQuantity, false) !== '') {
        return true
      }
      return false
    },
    sortOptions () {
      /* Create an options list from our fields */
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
    productTableState (value, key, item) {
      let skus = item.skus
      for (let sku in skus) {
        if (skus[sku].status !== PRODUCT_STATES[0].value) {
          return 'Ver SKUs'
        }
      }

      return 'Activo'
    },
    cleanFilters () {
      this.filter = {
        name: null,
        estado: null,
        sku: {desde: null, hasta: null},
        upc: {desde: null, hasta: null},
        fecha: {desde: null, hasta: null},
        category: {id: null, text: null},
        fromQuantity: null,
        toQuantity: null,
        account: null
      }
      this.$emit('clear-filters')
      this.$refs.productTable.refresh()
    },
    selectCategory (res) {
      this.filter.category = res
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    filterTable () {
      this.$refs.productTable.refresh()
    },
    exportCSV () {
      this.loading = true
      this.$emit('error', '')
      return this.getInventoryCSV(this.filter).then(
        (csvFile) => {
          this.loading = false
          this._exportCSV(csvFile, 'inventoryReportCSV.csv')
        },
        (error) => {
          this.loading = false
          let errorText = error.body.message || 'Error obteniendo el reporte de pedidos'
          this.$emit('error', errorText)
        }
      )
    },
    itemProvider (tableFilterInfo) {
      this.tableFilterInfo = tableFilterInfo
      this.loading = true
      return this.getProducts(tableFilterInfo, this.filter).then(
        (response) => {
          this.loading = false
          this.totalRows = parseInt(response.headers.get('X-Total-Count'))
          console.log(response.body)
          return response.body
        },
        (error) => {
          this.loading = false
          let errorText = error.body.message || 'Error obteniendo el inventario'
          this.$emit('error', errorText)
          return []
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  .product-list {
    .btn-link {
      color: #666666;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    tr:hover {
      cursor: pointer
    }

    .inventoryContainer {
      display: inline-block;

      .inventoryTotal {
        font-weight: bolder;
        font-size: 16px;
      }

      .inventoryReserved {
        color: #777;
      }
    }

    .priceCol {
      .discount {
        font-size: 12px;
        font-weight: bolder;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/InventoryReport.vue